import { render, staticRenderFns } from "./StatisticAIConfig.vue?vue&type=template&id=cc6b6c96"
import script from "./StatisticAIConfig.vue?vue&type=script&lang=js"
export * from "./StatisticAIConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports